import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Radar } from "lucide-react";
import ThemeToggle from "@/components/ThemeToggle";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await login(email, password);
      nav("/", { replace: true });
    } catch (ex) {
      setErr(ex?.response?.data?.message || ex?.response?.data?.detail || ex.message || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 relative" style={{ background: "var(--bg)" }}>
      <div className="absolute inset-0 pointer-events-none"
           style={{ backgroundImage: "url('https://images.unsplash.com/photo-1557264337-e8a93017fe92?crop=entropy&cs=srgb&fm=jpg&q=85')",
                    backgroundSize: "cover", backgroundPosition: "center", opacity: 0.15 }} />
      <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, color-mix(in srgb, var(--bg) 40%, transparent), color-mix(in srgb, var(--bg) 95%, transparent) 70%)" }} />

      <div className="absolute top-4 right-4 z-10"><ThemeToggle /></div>

      <div className="relative z-10 w-full max-w-[420px]">
        <div className="flex items-center gap-2 mb-8">
          <div className="w-9 h-9 rounded-md flex items-center justify-center" style={{ background: "linear-gradient(135deg,#FF453A,#BF5AF2)" }}>
            <Radar size={18} color="#fff" strokeWidth={2.4} />
          </div>
          <div>
            <div className="font-display text-[18px] leading-tight">Prioris</div>
            <div className="text-[10px] uppercase tracking-[0.18em]" style={{ color: "var(--text-muted)" }}>Foundation Release v0.1</div>
          </div>
        </div>
        <h1 className="font-display text-3xl mb-2 tracking-tight">Sign in</h1>
        <p className="text-[13px] mb-6" style={{ color: "var(--text-secondary)" }}>
          Transform every customer signal into intelligent business action.
        </p>
        <form onSubmit={onSubmit} className="card p-6 space-y-4" data-testid="login-form">
          <div>
            <label className="text-[11px] uppercase tracking-[0.15em]" style={{ color: "var(--text-muted)" }}>Email</label>
            <input className="input mt-1" data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div>
            <label className="text-[11px] uppercase tracking-[0.15em]" style={{ color: "var(--text-muted)" }}>Password</label>
            <input className="input mt-1" type="password" data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          {err && <div className="text-[12px] b-rev badge" data-testid="login-error">{err}</div>}
          <button type="submit" className="btn w-full justify-center" data-testid="login-submit" disabled={loading}>
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
